import * as m from "mithril";
import * as dayjs from 'dayjs';
import { MessageProvider } from '../context/AppMessages';
import { getBusTypeString, getIntlStringValue } from "../helpers/StringHelpers";
import './TripSearchResultSummaryView.css';
import MiniTripItineraryView from "./MiniTripItineraryView";
import CustomSvgIcon, { CustomSvgIconType } from "./CustomSvgIcon";
import { SeatSelectionDTO, TripDTO, TripResultDTO } from "../apiclient/ApiDtos";

interface Attrs {
    messageProvider: MessageProvider,
    numberOfSeats: number,
    tripResult: TripResultDTO,
    tripDetails?: TripDTO,
    showingDate?: boolean,
    hideTripPriceRange?: boolean,
    selectedSeats?: SeatSelectionDTO[] | null,
    showAsMultipleSeatPrice?: boolean
}

function TripSearchResultSummaryView(): m.Component<Attrs> {
    return {
        view(vnode) {
            let tripDetails = vnode.attrs.tripDetails;
            var result = tripDetails ? tripDetails : vnode.attrs.tripResult;
            let currLang = vnode.attrs.messageProvider.getCurrentLang();

            let hour24 = dayjs(result.departure.scheduledAt).hour();
            let dayNightIconClass: CustomSvgIconType = (hour24 < 16) ? 'sun' : 'moon';
            let dayNightLabel = getDayRangeLabel(hour24, vnode.attrs.messageProvider);

            let operatorLabel = getIntlStringValue(result.operator.name, currLang);
            let busTypeLabel = getBusTypeString(result, currLang);

            let hasDifferentOrigin = result.origin ?
                result.origin.location.id != result.departure.location.id : false;
            let hasDifferentOriginDate = hasDifferentOrigin ?
                dayjs(result.origin.scheduledAt).day() != dayjs(result.departure.scheduledAt).day() : false;

            let showPriceWithDetails = tripDetails && !tripDetails.mixedSeatTypesInBookingAllowed && (tripDetails.priceRange.max.amount > tripDetails.priceRange.min.amount);
            return m("div", [
                m("div", { class: "d-flex flex-row justify-content-between" }, [
                    m("div.mr-2", [
                        m("span", { class: "font-weight-bold text-primary-variant" },
                            [
                                (vnode.attrs.showingDate) ? dayjs(result.departure.scheduledAt).format("MMM D") + ", " : null,
                                dayjs(result.departure.scheduledAt).format("hh:mm A")
                            ]),
                        m("span", [
                            m("span", { class: " mx-1 " },
                                m(CustomSvgIcon, {
                                    iconType: dayNightIconClass,
                                    themeCssClass: "svg-info svg-small"
                                })
                            ),
                            m("span.text-body-sm", dayNightLabel)
                        ]),

                        m("div", [
                            m("span", { class: "text-body-sm font-weight-bold text-secondary" }, operatorLabel),
                            m(CustomSvgIcon, {
                                iconType: 'circle_dot',
                                themeCssClass: "svg-muted svg-small"
                            }),
                            m("span", { class: "text-body-sm font-weight-bold text-secondary" }, busTypeLabel),
                        ]),


                        /* (result.highlights && result.highlights.length > 0) &&
                        m("div.mt-1", [
                            result.highlights.map(hl => {
                                return m("span.operator-tag-pickup-service mr-1  mb-1 font-weight-bold",
                                    getIntlStringValue(hl, vnode.attrs.messageProvider.getCurrentLang())
                                )
                            })
                        ]
                        ), */
                    ]),
                    vnode.attrs.hideTripPriceRange == true ? null :
                       showPriceWithDetails ? 
                       [
                                m("div", { class: "flex-shrink-0" }, [
                                    m("div.text-right", [
                                        m("small", { class: "text-success" }, "MMK "),
                                        m("span.font-weight-bold", { class: "text-success" },
                                            result.priceRange.min.amount.toLocaleString("en-US"),
                                            (result.priceRange.max.amount > result.priceRange.min.amount) ? " +" : ""
                                        ),
                                        m("div.small text-muted_ text-price-total", vnode.attrs.messageProvider.get("common.price_per_seat"))
                                    ]),

                                    m("div.text-right ml-1 mt-3", [
                                        vnode.attrs.numberOfSeats > 1 ?
                                            [
                                                m("small",
                                                    m("span.text-price-total_", vnode.attrs.numberOfSeats),
                                                    m("span.ml-1.text-price-total_", vnode.attrs.messageProvider.get("seats"))
                                                    ,
                                                    " ▹ ",
                                                    m("small.text-price-total_", { class: "" }, "MMK "),
                                                    m("span.text-price-total_",
                                                        (result.priceRange.min.amount * vnode.attrs.numberOfSeats).toLocaleString("en-US"),
                                                        (result.priceRange.max.amount > result.priceRange.min.amount) ? " +" : ""
                                                    )
                                                )
                                            ]
                                            : "",
                                    ]),

                                ])
                            ]
                            :
                            [
                                m("div", { class: "flex-shrink-0" }, [
                                    m("div.text-right", [
                                        m("small", { class: "text-success" }, "MMK "),
                                        m("span.font-weight-bold", { class: "text-success" },
                                            result.priceRange.min.amount.toLocaleString("en-US"),
                                            (result.priceRange.max.amount > result.priceRange.min.amount) ? " +" : ""
                                        ),
                                        m("div.small text-muted_ text-price-total", vnode.attrs.messageProvider.get("common.price_per_seat"))
                                    ]),

                                    m("div.text-right ml-1 mt-3", [
                                        vnode.attrs.numberOfSeats > 1 ?
                                            [
                                                m("small",
                                                    m("span.text-price-total_", vnode.attrs.numberOfSeats),
                                                    m("span.ml-1.text-price-total_", vnode.attrs.messageProvider.get("seats"))
                                                    ,
                                                    " ▹ ",
                                                    m("small.text-price-total_", { class: "" }, "MMK "),
                                                    m("span.text-price-total_",
                                                        (result.priceRange.min.amount * vnode.attrs.numberOfSeats).toLocaleString("en-US"),
                                                        (result.priceRange.max.amount > result.priceRange.min.amount) ? " +" : ""
                                                    )
                                                )
                                            ]
                                            : "",
                                    ]),

                                ])

                            ]
                    ,

                ]),

                
                
                m("div.mt-1 px-1 py-2 bg-light rounded",
                    m("span.text-body-sm", { class: "text-muted" },
                        getIntlStringValue(result.fullRouteName, currLang)
                    ),

                ),

                m("div.mt-1", [
                    m(MiniTripItineraryView, {
                        messageProvider: vnode.attrs.messageProvider,
                        trip: result,
                        size: 'small',
                        fill: false
                    })
                ]),

                

            ]);
        }
    }
}

export function getDayRangeLabel(hour24: number, messageProvider: MessageProvider) {
    return (hour24 < 16) ?
        (hour24 < 12) ? messageProvider.get("trip.morning") : messageProvider.get("trip.afternoon") :
        messageProvider.get("trip.evening");
}

export default TripSearchResultSummaryView;